<template>

  <slide-in :class="['text-and-image', reversed ? 'text-and-image--reversed' : '']" :direction="!reversed ? 'left' : 'right'">

    <div v-if="$slots.image" class="text-and-image__image-side" :style="`flex: 0 0 ${imageWidth}px;`">
      <slot name="image"/>
    </div>

    <branded-box class="text-and-image__text-side" :direction="reversed ? 'right' : 'left'">
      <h1 class="text-and-image__header"><slot name="header" /></h1>
      <div class="text-and-image__text"><slot name="text"/></div>
    </branded-box>

  </slide-in>

</template>

<script>

  import BrandedBox from "@/components/branded-box.vue"
  import SlideIn from "./slide-in";

  export default {
    components: {
      SlideIn,
      BrandedBox
    },
    props: {
      reversed: {
        type: Boolean,
        default: false,
      },
      imageWidth: {
        type: Number,
      },
      hideimageOnMobile: {
        type: Boolean,
        default: false,
      }
    },
  }

</script>

<style lang="scss">

  @import "/../assets/scss/palette";
  @import "/../assets/scss/border";

  .text-and-image {
    display:  flex;
    margin-bottom: 1rem;

    &--reversed {
      transform: translateX(-100%);
      flex-flow: row-reverse;
    }

    &--visible {
      transform: none;
    }

    &__image-side {

      flex: 1;


      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }

    }

    &__text-side {

      flex: 1;
    }

    &__header {
      margin-bottom: 1rem;
      border-bottom: 1px solid white;
      padding: 1rem;
      text-align: center;
    }

    &__text {
      padding: 1rem;
      flex: 1;
      display: flex;
      flex-flow: column;
      justify-content: center;

      p, ul {
        margin-bottom: 1rem;
      }

      ul {
        margin-left: 1rem;
      }
    }

  }

  @media (max-width: 1000px) {
    .text-and-image {
      flex-flow: column;

      &__image-side {
        flex: none !important;
      }
    }
  }

</style>